module.exports={Remove:"Odebrat"};